import { baseCRUDAPI } from './base';

export default class Email extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Email');
  }

  async sendConfirmationEmail(email) {
    return this.axiosObject.post(
      `${this.apiBaseName}/SendEmailConfirmation`,
      null,
      {
        params: { email },
      },
    );
  }

  async confirmEmail({ email, code }) {
    return this.axiosObject.post(
      `${this.apiBaseName}/confirmEmail`,
      null,
      {
        params: {
          email,
          code,
        },
      },
    );
  }
}
